var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplitPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "split-PDF-files_400x240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 240,
    viewBox: "0 0 400 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_310683",
    "data-name": "Group 310683",
    transform: "translate(1100.556 -6791.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155518",
    "data-name": "Group 155518",
    transform: "translate(-1045.251 6831.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_6847",
    "data-name": "Line 6847",
    d: "M-.089,3.8A1.411,1.411,0,0,1-1.5,2.39V-.089A1.411,1.411,0,0,1-.089-1.5,1.411,1.411,0,0,1,1.321-.089V2.39A1.411,1.411,0,0,1-.089,3.8Z",
    transform: "translate(6.569 1.5)",
    fill: "#44b755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6848",
    "data-name": "Line 6848",
    d: "M-.089,3.8A1.411,1.411,0,0,1-1.5,2.39V-.089A1.411,1.411,0,0,1-.089-1.5,1.411,1.411,0,0,1,1.321-.089V2.39A1.411,1.411,0,0,1-.089,3.8Z",
    transform: "translate(6.569 9.157)",
    fill: "#44b755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6850",
    "data-name": "Line 6850",
    d: "M1.411,5.3A1.411,1.411,0,0,1,0,3.89V1.411a1.411,1.411,0,1,1,2.821,0V3.89A1.411,1.411,0,0,1,1.411,5.3Z",
    transform: "translate(12.959 5.069) rotate(90)",
    fill: "#44b755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6849",
    "data-name": "Line 6849",
    d: "M1.411,5.3A1.411,1.411,0,0,1,0,3.89V1.411a1.411,1.411,0,1,1,2.821,0V3.89A1.411,1.411,0,0,1,1.411,5.3Z",
    transform: "translate(5.301 5.069) rotate(90)",
    fill: "#44b755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155517",
    "data-name": "Group 155517",
    transform: "translate(-1081.5 6841.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_6847-2",
    "data-name": "Line 6847",
    d: "M-.089,8.108A1.411,1.411,0,0,1-1.5,6.7V-.089A1.411,1.411,0,0,1-.089-1.5,1.411,1.411,0,0,1,1.321-.089V6.7A1.411,1.411,0,0,1-.089,8.108Z",
    transform: "translate(12.434 1.5)",
    fill: "#0d66d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6848-2",
    "data-name": "Line 6848",
    d: "M-.089,8.108A1.411,1.411,0,0,1-1.5,6.7V-.089A1.411,1.411,0,0,1-.089-1.5,1.411,1.411,0,0,1,1.321-.089V6.7A1.411,1.411,0,0,1-.089,8.108Z",
    transform: "translate(12.434 16.582)",
    fill: "#0d66d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6850-2",
    "data-name": "Line 6850",
    d: "M1.411,9.608A1.411,1.411,0,0,1,0,8.2V1.411a1.411,1.411,0,1,1,2.821,0V8.2A1.411,1.411,0,0,1,1.411,9.608Z",
    transform: "translate(24.69 10.934) rotate(90)",
    fill: "#0d66d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6849-2",
    "data-name": "Line 6849",
    d: "M1.411,9.608A1.411,1.411,0,0,1,0,8.2V1.411a1.411,1.411,0,1,1,2.821,0V8.2A1.411,1.411,0,0,1,1.411,9.608Z",
    transform: "translate(9.608 10.934) rotate(90)",
    fill: "#0d66d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156060",
    "data-name": "Group 156060",
    transform: "translate(-732.984 6971.67)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6847-3",
    "data-name": "Line 6847",
    y2: 2.48,
    transform: "translate(5.069)",
    fill: "none",
    stroke: "#ffc294",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6848-3",
    "data-name": "Line 6848",
    y2: 2.48,
    transform: "translate(5.069 7.657)",
    fill: "none",
    stroke: "#ffc294",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6850-3",
    "data-name": "Line 6850",
    y2: 2.48,
    transform: "translate(10.138 5.069) rotate(90)",
    fill: "none",
    stroke: "#ffc294",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6849-3",
    "data-name": "Line 6849",
    y2: 2.48,
    transform: "translate(2.48 5.069) rotate(90)",
    fill: "none",
    stroke: "#ffc294",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310686",
    "data-name": "Group 310686",
    transform: "translate(0 -0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102849",
    "data-name": "Path 102849",
    d: "M-.119,62.422A1.881,1.881,0,0,1-2,60.541V56.3A1.881,1.881,0,0,1-.119,54.421,1.881,1.881,0,0,1,1.761,56.3v4.239A1.881,1.881,0,0,1-.119,62.422Zm0-13.642A1.881,1.881,0,0,1-2,46.9V42.2A1.881,1.881,0,0,1-.119,40.316,1.881,1.881,0,0,1,1.761,42.2v4.7A1.881,1.881,0,0,1-.119,48.779Zm0-14.105A1.881,1.881,0,0,1-2,32.793v-4.7A1.881,1.881,0,0,1-.119,26.211a1.881,1.881,0,0,1,1.881,1.881v4.7A1.881,1.881,0,0,1-.119,34.674Zm0-14.105A1.881,1.881,0,0,1-2,18.688v-4.7A1.881,1.881,0,0,1-.119,12.105a1.881,1.881,0,0,1,1.881,1.881v4.7A1.881,1.881,0,0,1-.119,20.569Zm0-14.105A1.881,1.881,0,0,1-2,4.582v-4.7A1.881,1.881,0,0,1-.119-2,1.881,1.881,0,0,1,1.761-.119v4.7A1.881,1.881,0,0,1-.119,6.463Z",
    transform: "translate(-858.142 6929.223)",
    fill: "#1473e6",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_310426",
    "data-name": "Group 310426",
    transform: "translate(-871.12 6836.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102848",
    "data-name": "Path 102848",
    d: "M-283.357-42.622l-5.126-6.7c-.5-.658-1.24-1.984-2.48-1.24-1.24.909-.5,1.819,0,2.645,1.57,2.562,4.382,6.118,5.7,8.1a2.026,2.026,0,0,1,.331,1.24,2.365,2.365,0,0,1-.414,1.406,9.3,9.3,0,0,1-.992,1.736c-.331.578-.658,1.075-.992,1.57a5.322,5.322,0,0,0-1.984-.414,5.293,5.293,0,0,0-3.77,1.58A5.293,5.293,0,0,0-294.6-28.9a5.346,5.346,0,0,0,5.29,5.373,5.346,5.346,0,0,0,5.29-5.373,5,5,0,0,0-.744-2.727,13.26,13.26,0,0,1,1.4-3.472c.827-1.819,2.315-1.819,3.142,0a30.007,30.007,0,0,1,1.406,3.472,5.2,5.2,0,0,0-.744,2.727,5.346,5.346,0,0,0,5.29,5.373,5.293,5.293,0,0,0,3.77-1.58,5.293,5.293,0,0,0,1.521-3.794,5.346,5.346,0,0,0-5.29-5.373,5.321,5.321,0,0,0-1.984.414c-.578-1.158-1.158-2.069-1.736-3.224a2.947,2.947,0,0,1-.248-2.727c1.323-1.984,4.381-5.539,5.87-8.181.5-.909,1.075-1.736-.165-2.645-1.323-.744-1.9.578-2.4,1.24l-5.29,6.7C-281.7-40.395-281.869-40.477-283.357-42.622Zm-5.952,10.908a2.65,2.65,0,0,1,1.952.775,2.65,2.65,0,0,1,.775,1.952,3.019,3.019,0,0,1-2.727,3.142,2.929,2.929,0,0,1-2.893-2.893,3,3,0,0,1,2.893-2.975Zm15.128,0a2.929,2.929,0,0,1,2.894,2.893,2.929,2.929,0,0,1-2.893,2.893,2.965,2.965,0,0,1-2.727-3.142,2.584,2.584,0,0,1,.784-1.92,2.584,2.584,0,0,1,1.944-.725Z",
    transform: "translate(294.601 110.425)",
    fill: "#1473e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102849-2",
    "data-name": "Path 102849",
    d: "M-.119,48.779A1.881,1.881,0,0,1-2,46.9V42.2A1.881,1.881,0,0,1-.119,40.316,1.881,1.881,0,0,1,1.761,42.2v4.7A1.881,1.881,0,0,1-.119,48.779Zm0-14.105A1.881,1.881,0,0,1-2,32.793v-4.7A1.881,1.881,0,0,1-.119,26.211a1.881,1.881,0,0,1,1.881,1.881v4.7A1.881,1.881,0,0,1-.119,34.674Zm0-14.105A1.881,1.881,0,0,1-2,18.688v-4.7A1.881,1.881,0,0,1-.119,12.105a1.881,1.881,0,0,1,1.881,1.881v4.7A1.881,1.881,0,0,1-.119,20.569Zm0-14.105A1.881,1.881,0,0,1-2,4.582v-4.7A1.881,1.881,0,0,1-.119-2,1.881,1.881,0,0,1,1.761-.119v4.7A1.881,1.881,0,0,1-.119,6.463Z",
    transform: "translate(12.978 2)",
    fill: "#1473e6",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310684",
    "data-name": "Group 310684",
    transform: "translate(0 10.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154217",
    "data-name": "Rectangle 154217",
    width: 99.988,
    height: 104.782,
    rx: 14,
    transform: "translate(-837.699 6850.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_154217_-_Outline",
    "data-name": "Rectangle 154217 - Outline",
    d: "M13.165,3.761a9.414,9.414,0,0,0-9.4,9.4V91.617a9.414,9.414,0,0,0,9.4,9.4H86.823a9.414,9.414,0,0,0,9.4-9.4V13.165a9.414,9.414,0,0,0-9.4-9.4H13.165m0-3.761H86.823A13.165,13.165,0,0,1,99.988,13.165V91.617a13.165,13.165,0,0,1-13.165,13.165H13.165A13.165,13.165,0,0,1,0,91.617V13.165A13.165,13.165,0,0,1,13.165,0Z",
    transform: "translate(-837.699 6850.056)",
    fill: "#d1cfcf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160756",
    "data-name": "Group 160756",
    transform: "translate(-814.086 6870.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101157",
    "data-name": "Path 101157",
    d: "M15.2-91.55a5.7,5.7,0,0,0-5.813,5.561v48.12A5.7,5.7,0,0,0,15.2-32.308H54.349a5.7,5.7,0,0,0,5.813-5.561v-39.5a4.448,4.448,0,0,0-1.424-3.291L48.654-90.189a8.769,8.769,0,0,0-3.443-1.361Z",
    transform: "translate(-7.972 92.961)",
    fill: "#f9eced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101157_-_Outline",
    "data-name": "Path 101157 - Outline",
    d: "M15.1-93.05H45.256l.131.024a9.538,9.538,0,0,1,4.175,1.734L59.642-81.74a5.8,5.8,0,0,1,1.841,4.26V-37.9a6.741,6.741,0,0,1-2.116,4.887,7.35,7.35,0,0,1-5.106,2.032H15.107A7.351,7.351,0,0,1,10-33.018,6.739,6.739,0,0,1,7.883-37.9V-86.132A6.741,6.741,0,0,1,10-91.018,7.35,7.35,0,0,1,15.1-93.05Zm29.877,2.689H15.109a4.335,4.335,0,0,0-4.4,4.231V-37.9a4.335,4.335,0,0,0,4.4,4.229h39.15a4.335,4.335,0,0,0,4.4-4.231V-77.5a3.164,3.164,0,0,0-1-2.327l0,0-10.089-9.56A6.969,6.969,0,0,0,44.981-90.361Z",
    transform: "translate(-7.883 93.05)",
    fill: "#d7373f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160820",
    "data-name": "Group 160820",
    transform: "translate(-804.683 6880.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101405",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 2)",
    fill: "#d7373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-2",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 9.523)",
    fill: "#d7373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-3",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 17.046)",
    fill: "#d7373f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310685",
    "data-name": "Group 310685",
    transform: "translate(0 10.954)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149938",
    "data-name": "Rectangle 149938",
    width: 167.103,
    height: 104.782,
    rx: 14,
    transform: "translate(-1047.177 6850.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149938_-_Outline",
    "data-name": "Rectangle 149938 - Outline",
    d: "M13.165,3.761a9.414,9.414,0,0,0-9.4,9.4V91.617a9.414,9.414,0,0,0,9.4,9.4H153.938a9.414,9.414,0,0,0,9.4-9.4V13.165a9.414,9.414,0,0,0-9.4-9.4H13.165m0-3.761H153.938A13.165,13.165,0,0,1,167.1,13.165V91.617a13.165,13.165,0,0,1-13.165,13.165H13.165A13.165,13.165,0,0,1,0,91.617V13.165A13.165,13.165,0,0,1,13.165,0Z",
    transform: "translate(-1047.237 6850.056)",
    fill: "#d1cfcf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_310429",
    "data-name": "Group 310429",
    transform: "translate(-1024.608 6871.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310427",
    "data-name": "Group 310427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160756-2",
    "data-name": "Group 160756",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101157-2",
    "data-name": "Path 101157",
    d: "M15.2-91.55a5.7,5.7,0,0,0-5.813,5.561v48.12A5.7,5.7,0,0,0,15.2-32.308H54.349a5.7,5.7,0,0,0,5.813-5.561v-39.5a4.448,4.448,0,0,0-1.424-3.291L48.654-90.189a8.769,8.769,0,0,0-3.443-1.361Z",
    transform: "translate(-7.972 92.961)",
    fill: "#f9eced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101157_-_Outline-2",
    "data-name": "Path 101157 - Outline",
    d: "M15.1-93.05H45.256l.131.024a9.538,9.538,0,0,1,4.175,1.734L59.642-81.74a5.8,5.8,0,0,1,1.841,4.26V-37.9a6.741,6.741,0,0,1-2.116,4.887,7.35,7.35,0,0,1-5.106,2.032H15.107A7.351,7.351,0,0,1,10-33.018,6.739,6.739,0,0,1,7.883-37.9V-86.132A6.741,6.741,0,0,1,10-91.018,7.35,7.35,0,0,1,15.1-93.05Zm29.877,2.689H15.109a4.335,4.335,0,0,0-4.4,4.231V-37.9a4.335,4.335,0,0,0,4.4,4.229h39.15a4.335,4.335,0,0,0,4.4-4.231V-77.5a3.164,3.164,0,0,0-1-2.327l0,0-10.089-9.56A6.969,6.969,0,0,0,44.981-90.361Z",
    transform: "translate(-7.883 93.05)",
    fill: "#d7373f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160820-2",
    "data-name": "Group 160820",
    transform: "translate(9.403 10.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-4",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 2)",
    fill: "#d7373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-5",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 9.523)",
    fill: "#d7373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-6",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 17.046)",
    fill: "#d7373f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310428",
    "data-name": "Group 310428",
    transform: "translate(68.646 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160756-3",
    "data-name": "Group 160756",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101157-3",
    "data-name": "Path 101157",
    d: "M15.2-91.55a5.7,5.7,0,0,0-5.813,5.561v48.12A5.7,5.7,0,0,0,15.2-32.308H54.349a5.7,5.7,0,0,0,5.813-5.561v-39.5a4.448,4.448,0,0,0-1.424-3.291L48.654-90.189a8.769,8.769,0,0,0-3.443-1.361Z",
    transform: "translate(-7.972 92.961)",
    fill: "#f9eced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101157_-_Outline-3",
    "data-name": "Path 101157 - Outline",
    d: "M15.1-93.05H45.256l.131.024a9.538,9.538,0,0,1,4.175,1.734L59.642-81.74a5.8,5.8,0,0,1,1.841,4.26V-37.9a6.741,6.741,0,0,1-2.116,4.887,7.35,7.35,0,0,1-5.106,2.032H15.107A7.351,7.351,0,0,1,10-33.018,6.739,6.739,0,0,1,7.883-37.9V-86.132A6.741,6.741,0,0,1,10-91.018,7.35,7.35,0,0,1,15.1-93.05Zm29.877,2.689H15.109a4.335,4.335,0,0,0-4.4,4.231V-37.9a4.335,4.335,0,0,0,4.4,4.229h39.15a4.335,4.335,0,0,0,4.4-4.231V-77.5a3.164,3.164,0,0,0-1-2.327l0,0-10.089-9.56A6.969,6.969,0,0,0,44.981-90.361Z",
    transform: "translate(-7.883 93.05)",
    fill: "#d7373f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160820-3",
    "data-name": "Group 160820",
    transform: "translate(9.403 10.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-7",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 2)",
    fill: "#d7373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-8",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 9.523)",
    fill: "#d7373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405-9",
    "data-name": "Path 101405",
    d: "M26.389,1.761H-.119A1.881,1.881,0,0,1-2-.119,1.881,1.881,0,0,1-.119-2H26.389A1.881,1.881,0,0,1,28.27-.119,1.881,1.881,0,0,1,26.389,1.761Z",
    transform: "translate(2 17.046)",
    fill: "#d7373f"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248076",
    "data-name": "Rectangle 248076",
    width: 400,
    height: 240,
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitPdf);
export default __webpack_public_path__ + "static/media/split-pdf.a7318568250fdda62cd0886d3daf3a6c.svg";
export { ForwardRef as ReactComponent };